import React from "react";

function SupportPostSkeleton() {
  return (
    <div className="bg-slate-100 animate-pulse">
      <div className="max-w-3xl mx-auto py-12 px-4 lg:px-0">
        <div className="h-4 bg-slate-200 rounded w-1/3 mb-4" />
        <div className="h-8 bg-slate-200 rounded w-2/3 mb-6" />
        <div className="flex items-center border-y py-5 mb-8 max-w-3xl space-x-4">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div key={idx} className="h-4 bg-slate-200 rounded w-24" />
          ))}
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div key={idx} className="h-4 bg-slate-200 rounded" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SupportPostSkeleton;
